import './src/styles/global.css';
import 'prismjs/themes/prism-okaidia.css';
import 'focus-visible/dist/focus-visible.min';
